
import { Prop, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { ISideBar, IUser } from '@/types/types';
import { Getter } from 'vuex-class';
@Component({
  name: 'SideBarDrawer',
})
export default class SideBarDrawer extends Vue {
  @Prop({ required: false, default: false }) drawer!: boolean;
  @Getter('getNavigationDrawerState') drawerState!: boolean;

  @Prop({ required: true, default: () => [] }) links!: ISideBar[];
  @Prop({ required: true, default: null }) user!: IUser;

  photoFailed = false;

  get hasPhoto(): boolean {
    return !!(this.user && this.user.photo) && !this.photoFailed;
  }

  /* initials for the photo-less avatar: first letter of the first two words */
  get initials(): string {
    const name = (this.user && this.user.name) || '';
    const parts = name.trim().split(/\s+/).filter(Boolean).slice(0, 2);
    return parts.map((p) => p[0].toUpperCase()).join('') || '?';
  }

  /* the drawer state lives in the store; the prop reflects it back */
  closeOnOutsideClick(payload: boolean): void {
    this.$store.dispatch('navigationDrawer', payload, { root: true });
  }

  close(): void {
    this.closeOnOutsideClick(false);
  }
}
